import api from 'api'
import { DEFAULT_PARTNER_ACCOUNT_SETTINGS, RawPartnerAccountSettings } from 'types/PartnerAccountSettings'
import fetchWithToken from 'utils/fetchWithToken'

export const fetchPartnerAccountSettings = (accountKey: string): Promise<RawPartnerAccountSettings> =>
  fetchWithToken({
    baseUrl: api.partnerAdminUrl,
    path: `accounts/${accountKey}/settings`,
    useV5: false,
    useVersion: '',
    method: 'GET',
  })
    .then((response: Response) => response.json())
    .catch(() => DEFAULT_PARTNER_ACCOUNT_SETTINGS)
